<div class="page-shell page-shell--canvas">
  <div class="dc-wrapper">
    <div class="dc-layout">
      <div class="dc-section dc-sidebar">
        <div class="dc-section__header">
          <h2 class="dc-section__title">
            {{ (readOnly ? "menu.myBackgrounds" : "background.title") | translate }}
          </h2>
        </div>
        <div class="dc-section__content">
          @if (!readOnly && selected) {
            <div
              class="dc-employee-picker-wrap"
              [hidden]="!employeePickerReady"
            >
              <app-digital-card-employee-picker
                [value]="previewEmployee"
                [templateContextId]="pickerTemplateContextId"
                (valueChange)="onPreviewEmployeeChange($event)"
                (initialSelectionResolved)="onEmployeePickerInitialResolved()"
              ></app-digital-card-employee-picker>
            </div>
          }
          @if (!listBusy && !readOnly) {
            <button type="button" class="dc-add-card" (click)="createNew()">
              <mat-icon>add</mat-icon>
              <span>{{ "background.create" | translate }}</span>
            </button>
          }
          <div class="dc-list">
            @if (!listBusy) {
              @for (item of items; track item.backgroundId) {
                <button
                  type="button"
                  class="dc-list-item"
                  [class.dc-list-item--selected]="isSelected(item)"
                  (click)="select(item)"
                >
                  <div class="dc-list-meta">
                    <span class="dc-list-name">{{ item.name }}</span>
                  </div>
                </button>
              }
            }
          </div>
          @if (listBusy) {
            <div class="dc-list-syncing dc-list-syncing--sidebar" aria-busy="true">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
          }
        </div>
      </div>

      <div class="dc-section dc-main">
        @switch (mainPhase) {
          @case ("boot") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state dc-empty-state--syncing">
                <mat-spinner diameter="36"></mat-spinner>
                <p>{{ "background.syncing" | translate }}</p>
              </div>
            </div>
          }
          @case ("empty") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state">
                <mat-icon>image</mat-icon>
                @if (!readOnly) {
                  <button mat-raised-button color="primary" (click)="createNew()">
                    <mat-icon>add</mat-icon>
                    {{ "background.addFirst" | translate }}
                  </button>
                }
              </div>
            </div>
          }
          @default {
            @if (mainReady) {
              <div class="dc-section__header dc-main-header">
                <h2 class="dc-section__title">{{ selected!.name }}</h2>
                <div class="dc-actions">
                  @if (!readOnly) {
                    <button type="button" (click)="editSelected()" class="action-btn">
                      <mat-icon>edit</mat-icon>
                      {{ "edit" | translate }}
                    </button>
                  }
                  <button
                    type="button"
                    (click)="download()"
                    [disabled]="isDownloading"
                    class="action-btn"
                  >
                    @if (isDownloading) {
                      <mat-spinner
                        diameter="18"
                        class="dbc1-spinner dbc1-spinner--sm"
                      ></mat-spinner>
                    } @else {
                      <mat-icon>download</mat-icon>
                    }
                    {{
                      (isDownloading
                        ? readOnly
                          ? "digitalCards.downloadingBackground"
                          : "digitalCards.downloadingBackgroundsZip"
                        : readOnly
                          ? "background.download"
                          : "background.downloadAllEmployeeBackgrounds"
                      ) | translate
                    }}
                  </button>
                  @if (!readOnly) {
                    <button
                      type="button"
                      (click)="remove()"
                      [disabled]="deleting"
                      class="action-btn action-btn--danger dc-action-delete"
                    >
                      @if (deleting) {
                        <mat-spinner
                          diameter="18"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>delete_outline</mat-icon>
                      }
                      {{
                        deleting
                          ? ("digitalCards.deleting" | translate)
                          : ("delete" | translate)
                      }}
                    </button>
                  }
                </div>
              </div>
            }
            <div class="dc-section__content dc-preview-content">
              @if (previewUrl && !previewLoadError) {
                <div
                  class="dc-preview-frame-wrap"
                  [class.dc-preview-frame-wrap--pending]="!mainReady"
                  [attr.aria-hidden]="!mainReady"
                >
                  <div class="dc-preview-background-wrap">
                    <img
                      [src]="previewUrl"
                      alt=""
                      class="dc-preview-background-img"
                      (load)="onPreviewLoad()"
                      (error)="onPreviewError()"
                    />
                  </div>
                </div>
              }
              @if (!mainReady) {
                <div class="dc-preview-content-center">
                  <div class="dc-empty-state dc-empty-state--syncing">
                    <mat-spinner diameter="36"></mat-spinner>
                    <p>{{ "background.syncing" | translate }}</p>
                  </div>
                </div>
              } @else if (previewLoadError || !previewUrl) {
                <div class="dc-preview-content-center">
                  <div class="dc-empty-state">
                    <mat-icon>image</mat-icon>
                    <p>{{ "digitalCards.previewUnavailable" | translate }}</p>
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
